import { useState } from 'react';
import { Label } from '../UI/label';

const TagsInput = ({
    fieldID,
    label,
    value = '',
    onChange,
    placeholder = '',
    required = false,
    disabled = false
}) => {
    const [tagInputValue, setTagInputValue] = useState('');

    const tagsArray = value ? value.split(',').filter(tag => tag.trim()) : [];

    const handleTagAdd = (newTag) => {
        if (!tagsArray.includes(newTag)) {
            const updatedTags = [...tagsArray, newTag];
            onChange(updatedTags.join(','));
        }
    };

    const handleTagRemove = (indexToRemove) => {
        const newTags = tagsArray.filter((_, i) => i !== indexToRemove);
        onChange(newTags.join(','));
    };

    const handleInputChange = (e) => {
        // Don't allow comma input
        const value = e.target.value.replace(/,/g, '');
        setTagInputValue(value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && tagInputValue.trim()) {
            e.preventDefault();
            const newTag = tagInputValue.trim();
            handleTagAdd(newTag);
            setTagInputValue('');
        }
        // Handle backspace to delete last tag when input is empty
        if (e.key === 'Backspace' && !tagInputValue && tagsArray.length > 0) {
            const newTags = tagsArray.slice(0, -1);
            onChange(newTags.join(','));
        }
    };

    return (
        <div className="space-y-1.5">
            <Label htmlFor={fieldID} required={required}>
                {label}
            </Label>

            {/* Regular input field - no tags inside */}
            <input
                id={fieldID}
                type="text"
                value={tagInputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                autoComplete="off"
                disabled={disabled}
                className="flex h-11 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sahi-input"
            />

            {/* Tags display below the input field */}
            {tagsArray.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                    {tagsArray.map((tag, index) => (
                        <span
                            key={index}
                            data-slot="badge"
                            className="inline-flex items-center sahi-radius border px-2.5 py-0.5 text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-none transition ease-in-out delay-150 hover:-translate-y-1 duration-200 border-foreground/10 text-foreground bg-card hover:bg-card/80 h-7 sahi-badge"
                            style={{ animationDuration: '2s' }}
                        >
                            {tag.trim()}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={`lucide lucide-x ml-2 h-4 w-4 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                                aria-hidden="true"
                                onClick={disabled ? undefined : () => handleTagRemove(index)}
                            >
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TagsInput;